/**
 * Ações disponíveis por linha da tabela.
 * Visibilidade de cada ação segue as regras de negócio do sistema:
 *   - ResetOTP:           caller com acesso Admin (1) ou Master (2)
 *   - Acesso a sistema:   caller com acesso Admin (1) ou Master (2)
 *   - Modificador acesso: caller com acesso Master (2) apenas
 *   - Trocar senha:       usuário alvo é externo (GRUPO=1) + caller Master ou Admin externo
 */
import React from "react";
import { useHistory } from "react-router-dom";
import * as MUI from "@mui/material";
import { FiMonitor, FiSettings } from "react-icons/fi";

import { DialogPassword, DialogResetOTP } from "../../../../components/Dialog";
import { UsuarioOperativaItem } from "../../../../interface/usuarioOperativa";

interface AcoesUsuarioProps {
  usuario: UsuarioOperativaItem;
  /** id_acesso do usuário logado como string ("0" | "1" | "2") */
  callerAcesso: string;
  /** grupo do usuário logado (0 = LDAP, 1 = Acesso Externo) */
  callerGrupo: number;
}

export const AcoesUsuario: React.FC<AcoesUsuarioProps> = ({
  usuario,
  callerAcesso,
  callerGrupo,
}) => {
  const history = useHistory();

  const isAdminOrMaster = callerAcesso === "1" || callerAcesso === "2";
  const isMaster = callerAcesso === "2";
  const podeAlterarSenha =
    usuario.GRUPO === 1 &&
    (isMaster || (callerAcesso === "1" && callerGrupo === 1));

  const irParaAcessoSistema = () =>
    history.push(`/gerenciamentodeusuario/acesso-a-sistema/${usuario.CPF}`);
  const irParaTipoAcesso = () =>
    history.push(`/gerenciamentodeusuario/tipo-acesso/${usuario.CPF}`);

  return (
    <MUI.Box display="flex" alignItems="center" gap={0.5}>
      {isAdminOrMaster && <DialogResetOTP CPF={usuario.CPF} />}

      {isAdminOrMaster && (
        <MUI.Tooltip title="Acesso a sistemas">
          <MUI.IconButton size="small" onClick={irParaAcessoSistema}>
            <FiMonitor style={{ color: "#46B556" }} />
          </MUI.IconButton>
        </MUI.Tooltip>
      )}

      {isMaster && (
        <MUI.Tooltip title="Modificar nível de acesso">
          <MUI.IconButton size="small" onClick={irParaTipoAcesso}>
            <FiSettings style={{ color: "#b5a446" }} />
          </MUI.IconButton>
        </MUI.Tooltip>
      )}

      {podeAlterarSenha && <DialogPassword CPF={usuario.CPF} />}
    </MUI.Box>
  );
};
